const GRAPHQL_URL = "https://graphql.datocms.com/";
const DATOCMS_API_TOKEN = "50fbbdf84945fb3a8a5c085a788b2b";

const getQuery = (slug:string) => `
  query GetCircleTheorem {
    gameCard(filter: { slug: {eq: "${slug}"}}) {
      slug
      cards {
        __typename
        ... on GameCardBlockRecord {
          id
          title
          image {
            url
          }
        }
      }
    }
  }
`;


export default async function fetchFromDato(slug:string) {
    try {
      const response = await fetch(GRAPHQL_URL, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${DATOCMS_API_TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: getQuery(slug),
          variables: {
            slug: slug
          }
        })
      });
      const { data } = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error)
      return {}
    }
}